export const ROUTES = Object.freeze({
  HOME: '/',
  BOOK_CONSULTATION: '/book-consultation',
  SERVICES: '/services',
  CONTACT: '/contact-us',
  NOT_FOUND: '*',
})
